import {RegistroEntrenador, RegistroEntrenadorJSON } from '../RegistroEntrenador/RegistroEntrenador';
export interface RegistroEntrenadorCursoJSON {
    rec_id: string;
    rec_reid: string;
    rec_horas: number;
    rec_descripcion: string;
    rec_tipo: string;
    rec_exterior: boolean;
}

export class RegistroEntrenadorCurso {
    protected constructor(
    private id: string,
    private reid: string,
    private horas: number,
    private descripcion: string,
    private tipo: string,
    private exterior: boolean) {}

    static createFrom( id: string,
    reid: string,
    horas: number,
    descripcion: string,
    tipo: string,
    exterior: boolean) {
        return new this( id,
        reid,
        horas,
        descripcion,
        tipo,
        exterior)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: RegistroEntrenadorCurso) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: RegistroEntrenadorCursoJSON) {
        return RegistroEntrenadorCurso.createFrom( entity.rec_id,
        entity.rec_reid,
        entity.rec_horas,
        entity.rec_descripcion,
        entity.rec_tipo,
        entity.rec_exterior)
    }

    toJSON(): RegistroEntrenadorCursoJSON {
        return {
            rec_id: this.getId(),
            rec_reid: this.getReid(),
            rec_horas: this.getHoras(),
            rec_descripcion: this.getDescripcion(),
            rec_tipo: this.getTipo(),
            rec_exterior: this.getExterior()
        }

    }

    getId(): string { return this.id; }

    getReid(): string { return this.reid; }

    getHoras(): number { return this.horas; }

    getDescripcion(): string { return this.descripcion; }

    getTipo(): string { return this.tipo; }

    getExterior(): boolean { return this.exterior; }

}

